import { computed } from 'vue';
import { blue, green, red, yellow } from '../colorsPreset.js';

const themeColorPreset = {
    green,
    red,
    blue,
    yellow,
};

const useThemes = ({ settings }) => {
    const activeTheme = computed(() => {
        return settings.value.colorScheme ?? 'custom';
    });

    const showcaseColors = computed(() => {
        return {
            '--lw-title': themeColorPreset[activeTheme.value]?.colorTitle || settings.value.colorTextBlocks,
            '--lw-text': themeColorPreset[activeTheme.value]?.colorText || settings.value.colorTextBlocks,
            '--lw-offer-bg': themeColorPreset[activeTheme.value]?.offerBg || settings.value.colorOffersBackground,
            '--lw-offer-bg-logo': themeColorPreset[activeTheme.value]?.offerBg || settings.value.colorOffersBackground,
            '--lw-offer-title': themeColorPreset[activeTheme.value]?.colorText || settings.value.colorTextBlocks,
            '--lw-offer-params-big': themeColorPreset[activeTheme.value]?.offerParamsBig || settings.value.colorOffersText,
            '--lw-offer-params': themeColorPreset[activeTheme.value]?.offerParams || settings.value.colorOffersText,
            '--lw-offer-params-name': themeColorPreset[activeTheme.value]?.offerParamsName || settings.value.colorTextBlocks,
            '--lw-offer-usp-bg': themeColorPreset[activeTheme.value]?.offerUspBg || settings.value.colorUspBackground,
            '--lw-offer-usp-color': themeColorPreset[activeTheme.value]?.offerUspColor || settings.value.colorUspText,
            '--lw-offer-approval-color': themeColorPreset[activeTheme.value]?.approvalColor || settings.value.colorTextBlocks,
            '--lw-offer-approval-percent': themeColorPreset[activeTheme.value]?.approvalPercent || settings.value.colorButtonBackground,
            '--lw-btn-bg': themeColorPreset[activeTheme.value]?.btnBg || settings.value.colorButtonBackground,
            '--lw-btn-color': themeColorPreset[activeTheme.value]?.btnColor || settings.value.colorButtonText,
            '--lw-btn-hover-color': themeColorPreset[activeTheme.value]?.btnHoverColor || settings.value.colorButtonTextHover,
            '--lw-btn-hover-bg': themeColorPreset[activeTheme.value]?.btnHoverBg || settings.value.colorButtonBackgroundHover,
            '--lw-btn-active-color': themeColorPreset[activeTheme.value]?.btnActiveColor || settings.value.colorButtonTextClick,
            '--lw-btn-active-bg': themeColorPreset[activeTheme.value]?.btnActiveBg || settings.value.colorButtonBackgroundClick,
            '--lw-font-family': settings.value.fontFamily,
        }
    });

    return { showcaseColors };
};

export default useThemes;